import {
  Button,
  Card,
  Checkbox,
  Heading,
  Input,
  Group,
  Spinner,
  Stack,
  Tabs,
} from "@chakra-ui/react";
import { Plus } from "lucide-react";
import { useState } from "react";
import { useDebounceState } from "../../../hooks/useDebounceState";
import { useCustomerSearch } from "../../../hooks/useCustomers";
import { useGroupSearch } from "../../../hooks/useGroupSearch";

type SearchCustomers = {
  customerNumbers: number[];
  isInvalid: boolean;
  setCustomers: (arg: number[]) => void;
  groupUuid?: string | null;
  setGroup: (arg?: string | null) => void;
};

export const SearchCustomers = ({
  customerNumbers,
  isInvalid: _isInvalid,
  setCustomers,
  groupUuid,
  setGroup,
}: SearchCustomers) => {
  const [searchQuery, updateSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounceState(searchQuery);
  const customerSearch = useCustomerSearch(debouncedSearchQuery, 4);
  const groupSearch = useGroupSearch(debouncedSearchQuery, 4);

  return (
    <Card.Root minW={300} minH={300} p={4}>
      <Stack>
        <Heading size="md">Finn kunde</Heading>
        <Tabs.Root defaultValue="customers">
          <Tabs.List>
            <Tabs.Trigger value="customers">Kunder</Tabs.Trigger>
            <Tabs.Trigger value="groups">Grupper</Tabs.Trigger>
          </Tabs.List>

          <Tabs.Content value="customers">
            <Group>
              <Input
                onChange={(e) => {
                  updateSearchQuery(e.target.value);
                }}
                placeholder="Søk"
              />
              {customerSearch.isLoading && <Spinner />}
            </Group>
            <Stack gap={4} py={4}>
              {customerSearch.data?.map((data) => (
                <Checkbox.Root
                  key={data.customerNumber}
                  bg="bg.muted"
                  p={4}
                  borderRadius="base"
                  checked={customerNumbers?.some(
                    (x) => x === data.customerNumber,
                  )}
                  onCheckedChange={(details) => {
                    if (details.checked && data.customerNumber) {
                      setCustomers([
                        ...(customerNumbers || []),
                        data.customerNumber,
                      ]);
                    } else {
                      setCustomers([
                        ...customerNumbers.filter(
                          (x) => x !== data.customerNumber,
                        ),
                      ]);
                    }
                  }}
                >
                  <Checkbox.HiddenInput />
                  <Checkbox.Control />
                  <Checkbox.Label>
                    {data.name}-{data.orgNumber}
                  </Checkbox.Label>
                </Checkbox.Root>
              ))}
              <Button>
                <Plus />
              </Button>
            </Stack>
          </Tabs.Content>
          <Tabs.Content value="groups">
            <Group>
              <Input
                onChange={(e) => {
                  updateSearchQuery(e.target.value);
                }}
                placeholder="Søk"
              />
              {groupSearch.isLoading && <Spinner />}
            </Group>
            <Stack gap={4} py={4}>
              {groupSearch.data?.map((data) => (
                <Checkbox.Root
                  key={data.uuid || data.groupName}
                  bg="bg.muted"
                  p={4}
                  borderRadius="base"
                  checked={data.uuid === groupUuid}
                  onCheckedChange={(details) => {
                    if (details.checked && data.uuid) {
                      setGroup(data.uuid);
                    } else {
                      setGroup(null);
                    }
                  }}
                >
                  <Checkbox.HiddenInput />
                  <Checkbox.Control />
                  <Checkbox.Label>
                    {data.groupName}: ({data.customers.length})
                  </Checkbox.Label>
                </Checkbox.Root>
              ))}
              <Button>
                <Plus />
              </Button>
            </Stack>
          </Tabs.Content>
        </Tabs.Root>
      </Stack>
    </Card.Root>
  );
};
